import type { TextFieldProps } from "@mui/material";
import { InputAdornment, TextField } from "@mui/material";
import type { KeyboardEvent } from "react";

type Props = Omit<TextFieldProps<"standard">, "onChange"> & {
  value: string;
  onValueChange: (value: string) => void;
};

const allowedChars = /[\d() -]/;
const sanitize = (input: string) => input.replace(/[^\d() -]/g, "");

const PhoneTextField = ({ value, onValueChange, slotProps, ...props }: Props) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key.length === 1 && !allowedChars.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <TextField
      {...props}
      value={value}
      onChange={(e) => onValueChange(sanitize(e.target.value))}
      onKeyDown={handleKeyDown}
      slotProps={{
        ...slotProps,
        input: {
          startAdornment: <InputAdornment position="start">+</InputAdornment>,
          ...slotProps?.input,
        },
        htmlInput: { inputMode: "tel", ...slotProps?.htmlInput },
      }}
    />
  );
};

export default PhoneTextField;
